export function getMilestone({ milestone }) {
  return milestone || null;
}

export default {
  getMilestone,
};
